import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadCognitoFormAnswers,
  deleteCognitoFormAnswer,
} from '../../../../../state/modules/cognitoFormAnswers/actions';
import CognitoFormAnswersList from '../components/CognitoFormAnswersList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.cognitoFormAnswers.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['cognitoFormAnswers', x]),
                schema.cognitoFormAnswer,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              email: x.registration?.email || '',
              username: x.registration?.username || '',
              care_guide_first_name: x.registration.care_guide_first_name || '',
              care_guide_last_name: x.registration.care_guide_last_name || '',
              ...x,
            };
          })
      : [],
    isLoading: state.cognitoFormAnswers.get('isLoading'),
    total: state.cognitoFormAnswers.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCognitoFormAnswers(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCognitoFormAnswer(id, cb));
    },
  };
};

const CognitoFormAnswersListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormAnswersList);

export default CognitoFormAnswersListContainer;
